<template>
  <v-container fluid>
    <BaseBreadcrumb
      :title="$vuetify.lang.t('$vuetify.VEHICLE_GROUPS.TITLE')"
      :breadcrumbs="[
        {
          text: $vuetify.lang.t('$vuetify.VEHICLE_GROUPS.TITLE'),
          disabled: true
        }
      ]"
    />
    <v-card>
      <v-card-text>
        <v-row class="d-flex align-center justify-end px-4">
          <v-btn color="success" @click="vehicleGroupEditDialog = true">
            <v-icon>mdi-plus</v-icon>
            {{ $vuetify.lang.t('$vuetify.VEHICLE_GROUPS.ADD_NEW') }}
          </v-btn>
        </v-row>
        <v-data-table
          :headers="[
            {
              text: 'ID',
              align: 'start',
              sortable: false,
              value: 'ID'
            },
            {
              text: $vuetify.lang.t('$vuetify.VEHICLE_GROUPS.GROUP_NAME'),
              align: 'start',
              sortable: false,
              value: 'name'
            },
            {
              text: '',
              align: 'end',
              sortable: false,
              value: 'actions'
            }
          ]"
          :items="vehicleGroups"
          hide-default-footer
          :items-per-page="-1"
        >
          <template v-slot:item.actions="props">
            <td class="d-flex align-center justify-end">
              <v-tooltip v-if="isGlobalAdmin" top>
                <template v-slot:activator="{ on }">
                  <v-btn
                    icon
                    @click="openVehicleGroupEditDialog(props.item)"
                    v-on="on"
                  >
                    <v-icon small>mdi-pencil</v-icon>
                  </v-btn>
                </template>
                <span>
                  {{ $vuetify.lang.t('$vuetify.EDIT') }}
                </span>
              </v-tooltip>
            </td>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
    <VehicleGroupEditDialog
      :visible="vehicleGroupEditDialog"
      @close="vehicleGroupEditDialog = false"
    />
  </v-container>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import VehicleGroupEditDialog from '@/components/VehicleGroupEditDialog'

export default {
  name: 'VehicleGroup',
  components: {
    VehicleGroupEditDialog
  },
  data() {
    return {
      vehicleGroupEditDialog: false
    }
  },
  computed: {
    ...mapGetters('authentication', ['isGlobalAdmin']),
    ...mapGetters('vehicleGroups', ['vehicleGroups', 'selectedVehicleGroup']),
    groupName: {
      get() {
        if (this.selectedVehicleGroup) {
          return this.selectedVehicleGroup.name
        }
        return ''
      },
      set(value) {
        return this.setVehicleGroupValue({ key: 'name', value })
      }
    }
  },
  created() {
    this.getAllVehicleGroups()
  },
  methods: {
    ...mapActions('vehicleGroups', ['getAllVehicleGroups']),
    ...mapMutations('vehicleGroups', [
      'setSelectedVehicleGroup',
      'setVehicleGroupValue'
    ]),
    openVehicleGroupEditDialog(group) {
      this.setSelectedVehicleGroup(group)
      this.vehicleGroupEditDialog = true
    }
  }
}
</script>
